import React from "react";
import { IntroVideo } from "components/IntroVideo";
import { Header } from "components/header";
import "./IntroVideoScreen.scss"
import { Button } from "components/button";
import { MovingfulExperienceCard } from "components/movingfulExperienceCard";
import { navigate } from "@reach/router";

export interface IntroVideoScreenProps {
    path?: string;
}

export interface IntroVideoScreenState {

}

class IntroVideoScreen extends React.Component<IntroVideoScreenProps, IntroVideoScreenState> {
    constructor(props: IntroVideoScreenProps) {
        super(props);
        this.state = {};
        
    }

    getStarted() {
        navigate("/move?question=bookingdetails")
    }

    render() {
        return (
            <div className="home-container" style={{padding:"0em 1em"}} >
                {/* <div className="video-screen-wrapper"> */}
                    <IntroVideo />
                    <MovingfulExperienceCard />
                    <div className="video-btn">
                        <Button
                            text={"My Estimate"}
                            width={"70vw"}
                            onClick={this.getStarted}
                        />
                    </div>
                {/* </div> */}
            </div>
        );
    }
}

export default IntroVideoScreen;